import API from "../api/manager";
import config from "../api/config";

const getProfiles = (query) => {
  return API({
    method: "GET",
    url: config.urls.user.index + query,
  });
};

const getInvitedProfiles = (query) => {
  return API({
    method: "GET",
    url: config.urls.user.invitedMediator + query,
  });
};

const getProfile = (id) => {
  return API({
    method: "GET",
    url: config.urls.user.index + `/${id}`,
  });
};

const setProfile = (id, data) => {
  return API({
    method: "PUT",
    url: config.urls.user.update + `/${id}`,
    data,
  });
};

const setConfig = (data) => {
  return API({
    method: "POST",
    url: config.urls.systemConfig,
    data,
  });
};

const getConfig = () => {
  return API(
    {
      method: "GET",
      url: config.urls.systemConfig,
    },
    false,
  );
};

const caseStages = (data) => {
  return API({
    method: "POST",
    url: config.urls.case.caseStages,
    data,
  });
};

const documentTypes = (data) => {
  return API({
    method: "POST",
    url: config.urls.case.documentTypes,
    data,
  });
};

const deleteCaseStages = (id) => {
  return API({
    method: "DELETE",
    url: `${config.urls.case.deleteCaseStages}/${id}`,
  });
};

const deleteDocumentTypes = (id) => {
  return API({
    method: "DELETE",
    url: `${config.urls.case.deleteDocumentTypes}/${id}`,
  });
};

const getCaseStages = () => {
  return API({
    method: "GET",
    url: config.urls.case.getCaseStages,
  });
};

const getDocumentTypes = () => {
  return API({
    method: "GET",
    url: config.urls.case.getDocumentTypes,
  });
};

const updateCaseStages = (id, data) => {
  return API({
    method: "PUT",
    url: config.urls.case.caseStages + `/${id}`,
    data,
  });
};

const updateRecordInMIS = () => {
  return API({
    method: "POST",
    url: config.urls.case.updateRecordInMIS,
  });
};

const getConfigAuth = () => {
  return API({
    method: "GET",
    url: config.urls.systemConfig,
  });
};

const ipAddressWhiteList = (data) => {
  return API({
    method: "POST",
    url: config.urls.ipAddressWhiteList,
    data,
  });
};

const clearQueue = (data) => {
  return API({
    method: "PUT",
    url: config.urls.clearQueue,
    data,
  });
};

const getIpAddressWhiteLists = () => {
  return API({
    method: "GET",
    url: config.urls.getIpAddressWhiteLists,
  });
};

const deleteIpAddressWhiteLists = (id, data) => {
  return API({
    method: "DELETE",
    url: config.urls.deleteIpAddressWhiteLists + `/${id}`,
    data,
  });
};

const updateIpAddressWhiteLists = (id, data) => {
  return API({
    method: "PUT",
    url: config.urls.ipAddressWhiteList + `/${id}`,
    data,
  });
};

const getPartyCodes = () => {
  return API({
    method: "GET",
    url: config.urls.getPartyCodes,
  });
};

const createPartyCode = (data) => {
  return API({
    method: "POST",
    url: config.urls.createPartyCode,
    data,
  });
};

const deletePartyCodes = (id) => {
  return API({
    method: "DELETE",
    url: config.urls.deletePartyCodes + `/${id}`,
  });
};

const updatePartyCode = (id, data) => {
  return API({
    method: "PUT",
    url: config.urls.createPartyCode + `/${id}`,
    data,
  });
};

const fetchWebinarConfigs = (query) => {
  return API({
    method: "GET",
    url: config.urls.webinarConfig + query,
  });
};

const fetchWebinarConfigById = (id) => {
  return API({
    method: "GET",
    url: `${config.urls.webinarConfig}/${id}`,
  });
};

const createWebinarConfig = (data) => {
  return API({
    method: "POST",
    url: config.urls.webinarConfig,
    data,
  });
};

const updateWebinarConfig = (id, data) => {
  return API({
    method: "PUT",
    url: `${config.urls.webinarConfig}/${id}`,
    data,
  });
};

const deleteWebinarConfig = (id) => {
  return API({
    method: "DELETE",
    url: `${config.urls.webinarConfig}/${id}`,
  });
};

export default {
  getConfig,
  setConfig,
  getProfiles,
  getProfile,
  setProfile,
  getInvitedProfiles,
  caseStages,
  documentTypes,
  deleteCaseStages,
  deleteDocumentTypes,
  getCaseStages,
  getDocumentTypes,
  updateCaseStages,
  updateRecordInMIS,
  getConfigAuth,
  ipAddressWhiteList,
  clearQueue,
  getIpAddressWhiteLists,
  deleteIpAddressWhiteLists,
  updateIpAddressWhiteLists,
  getPartyCodes,
  createPartyCode,
  updatePartyCode,
  deletePartyCodes,
  fetchWebinarConfigs,
  fetchWebinarConfigById,
  createWebinarConfig,
  updateWebinarConfig,
  deleteWebinarConfig,
};
